import { IAction } from 'core/actions/Actions.interfaces'
import { IAdminUserProfile } from './Reducers.interfaces'
import { buildActionType } from 'core/utils/api'
import ActionsList from 'core/actions/Actions.list'

const initialState: IAdminUserProfile = {
  data: undefined
}

export default function userProfile (state: IAdminUserProfile = initialState, action: IAction) {
  switch (action.type) {
    case buildActionType(ActionsList.FetchUserProfile, 'request'):
      return {
        ...state
      }
    case buildActionType(ActionsList.FetchUserProfile, 'success'):
      return {
        ...state,
        data: {
          ...action.payload,
        }
      }
    case buildActionType(ActionsList.FetchUserProfile, 'failure'):
      return {
        ...state
      }

    default:
      return state
  }
}
